<template>
<div class="companyList companyListPro" >
        <div class="chainTitle">生产公司</div>
        <div class="box">
            <DataEmpty v-if="isEmpty"></DataEmpty>
            <ul style="margin:10px auto;" v-else>
                <li v-if="tableData.length>0">
                    <el-table :data="tableData" border @cell-click="clickCompanyName">
                        <el-table-column  label="证券简称" prop="securityName">
                            <!-- <template slot-scope="scope">
                                <span class="leftName">{{ scope.row.securityName}}</span>
                                 <span >{{ scope.row.securityCode}}</span>
                            </template> -->
                        </el-table-column>
                        <el-table-column  label="证券代码" prop="securityCode"></el-table-column>
                    </el-table>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import DataEmpty from '../../productInfoComponents/dataEmpty.vue'

  export default {
    name: 'companyList',
    data() {
        return {
            tableData: [],     //生产公司
            isEmpty:false,
        }
    },
    components:{DataEmpty},
    computed:{...mapState(['productRouterInfo'])},
    created(){
        this.getCompanysByProduct(this.productRouterInfo);
    },
    methods: {
        //获取生产公司信息
        getCompanysByProduct(params){
            this.$store.dispatch('getCompanysByProduct',{productCode:params.productCode}).then( res => {
                if( res.data.retCode == '000'){
                    this.tableData = res.data.data
                    if(this.tableData.length==0){
                        this.isEmpty = true;
                    }
                }
            })
        },
         //点击公司，跳转相应公司
        clickCompanyName(row, event, column){
            let params = {}
            params.name = row.securityName;
            params.securityCode = row.securityCode;
            params.coCode = row.coCode
            params.type = 'company'
            this.$store.dispatch('productRouterInfo',params);
        }

    },
    mounted() {

    }
  }
</script>

<style lang="scss" src="../../../sass/productInfo/companyList.scss"></style>



// WEBPACK FOOTER //
// src/components/productInfoComponents/productCom/companyList.vue